(() => {
  const triggerSelector = '[data-muuv-open-inbox-chat]';

  const findChatActivator = (root) => {
    if (!root?.querySelector) return null;

    const direct = root.querySelector(
      'button.chat-toggle, .chat-app > button, button.activator, button[aria-label*="chat" i]'
    );
    if (direct) return direct;

    for (const element of root.querySelectorAll('*')) {
      const nested = findChatActivator(element.shadowRoot);
      if (nested) return nested;
    }

    return null;
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(triggerSelector);
    if (!trigger) return;

    const chatHost = document.getElementById('ShopifyChat') || document.querySelector('shopify-chat');
    const activator = findChatActivator(chatHost?.shadowRoot || chatHost);

    // Retain the contact-page href when Inbox has not loaded or is disabled.
    if (!activator) return;

    event.preventDefault();
    activator.click();
  });
})();
